import type { User } from '../../types';

/** Espelha backend is_change_manager: Admin Supremo ou flag can_manage_changes. */
export function isChangeManager(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return Boolean(user.can_manage_changes);
}

/** Pode consultar logs de auditoria do módulo (gestor ou flag secundária). */
export function canViewChangeSecurityAudit(user: User | null | undefined): boolean {
  if (!user) return false;
  if (isChangeManager(user)) return true;
  return Boolean(user.can_view_change_security_audit);
}

/** Espelha backend can_edit_cab_deck quando o detalhe já trouxe a flag calculada. */
export function canEditChangeCabDeck(
  user: User | null | undefined,
  change?: {
    can_edit_cab_deck?: boolean;
    created_by?: number | null;
    requester_id?: number | null;
  } | null,
): boolean {
  if (change?.can_edit_cab_deck !== undefined) {
    return Boolean(change.can_edit_cab_deck);
  }
  if (isChangeManager(user)) return true;
  const uid = user?.id;
  if (!uid || !change) return false;
  if (change.created_by === uid || change.requester_id === uid) return true;
  return false;
}

/** Botão Resetar para Agendado: só gestor, só na aba Transporte (status Transporte/Implementar). */
export function canShowResetToScheduled(
  change: { status?: string | null },
  user: User | null | undefined,
): boolean {
  if (!isChangeManager(user)) return false;
  return change.status === 'transporte' || change.status === 'implementar';
}

/** Redisparo do pacote na aba Subtarefas: gestor em Agendado ou Autorizar. */
export function canShowRedispatchPackage(
  change: { status?: string | null },
  user: User | null | undefined,
): boolean {
  if (!isChangeManager(user)) return false;
  return change.status === 'agendado' || change.status === 'autorizar';
}

/** Solicitante puro (não dono/criador) — mesmas travas de subtarefa e redisparo de aprovação. */
export function isChangeRequesterOnlyForOps(
  change: {
    requester_id?: number | null;
    change_owner_id?: number | null;
    created_by?: number | null;
  },
  user?: Pick<User, 'id'> | null,
): boolean {
  if (!user?.id || !change.requester_id) return false;
  if (user.id !== change.requester_id) return false;
  if (user.id === change.change_owner_id || user.id === change.created_by) return false;
  return true;
}
